module.exports = __webpack_public_path__ + "media/bootstrap-icons/tree-fill-5af9c873.svg";